var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('wc-page-title',{attrs:{"loading":_vm.isLoading,"title":_vm.title,"subtitle":_vm.subtitle}}),(_vm.project)?_c('router-view',{attrs:{"project":_vm.project},on:{"update":_vm.update,"updateProject":_vm.updateProject}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }